import i18n from "i18next";

import type { UserCourseLesson } from "api/schemas/UserCourse";
import type { ExerciseListItem } from "api/services/content/schemas/exercises";

import type { ActivityType } from "../types";

const isExercise = (activity: ExerciseListItem | UserCourseLesson): activity is ExerciseListItem => {
  return "exercise_id" in activity;
};

type NormalizedActivity = {
  activityType: ActivityType;
  id: number;
  title: string;
  imageUrl: string | null | undefined;
  levelCount: number;
  previewLabel: string;
};

export const normalizeActivity = (activity: ExerciseListItem | UserCourseLesson): NormalizedActivity => {
  if (isExercise(activity)) {
    const imageUrl = activity.levels?.[0]?.image_url || activity.levels?.[0]?.video_thumbnail_file_url;

    return {
      activityType: "exercise",
      id: activity.exercise_id,
      title: activity.levels?.[0]?.title || `Exercise ${activity.exercise_id}`,
      imageUrl,
      levelCount: activity.levels?.length || 0,
      previewLabel: i18n.t("treatment.editor.preview_activity", { activityType: "exercise" }),
    };
  }

  return {
    activityType: "lesson",
    id: activity.id,
    title: activity.title || `Lesson ${activity.id}`,
    imageUrl: activity.image_url,
    levelCount: activity.parts_count || 1,
    previewLabel: i18n.t("treatment.editor.preview_activity", { activityType: "lesson" }),
  };
};
